import { ReduxAsyncAction } from '../support/utils';
import dash_api from '../support/dash_api';

const FLIPPER_ROUTE = '/v1/flipper';

const TurnOnFlipperFeature = new ReduxAsyncAction('FLIPPER_TURN_ON_FEATURE');
TurnOnFlipperFeature.registerRequest(feature => {
  return dash_api
    .post(`${FLIPPER_ROUTE}/turn-on-feature`, { feature })
    .then(res => feature);
});

export const FLIPPER_ON = TurnOnFlipperFeature.constants;
export const turnOnFlipperFeature = TurnOnFlipperFeature.request;

const TurnOffFlipperFeature = new ReduxAsyncAction('FLIPPER_TURN_OFF_FEATURE');
TurnOffFlipperFeature.registerRequest(feature => {
  return dash_api
    .post(`${FLIPPER_ROUTE}/turn-off-feature`, { feature })
    .then(res => feature);
});

export const FLIPPER_OFF = TurnOffFlipperFeature.constants;
export const turnOffFlipperFeature = TurnOffFlipperFeature.request;

export const FLIPPER_HYDRATE = 'FLIPPER_HYDRATE';

export function hydrate() {
  return {
    type: FLIPPER_HYDRATE
  };
}
